export enum ESearchFilterActiveTypes{
    none = "none",
    global= "global",
    column = "column"
}